import {
  call, put, delay, select,
} from 'redux-saga/effects';
import moment from 'moment/moment';
import processError from '../../../utils/processError';
import {
  addProgressLog, setLogList, setProgressList, showProgressBar, stoppedProgressBar,
} from '../../System/actions';
import {
  importViolationSuccessful, importViolationFailed,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';
import { dateTimeStringFormatter } from '../../../utils/formatters';
import { SYSTEM_MODULE } from '../../../configs/moduleNames';
import { loadStatusImport } from '../../RegionRegistry/actions';

const getStop = state => {
  const {
    [SYSTEM_MODULE]: {
      stopProgressBar = false,
    },
  } = state;
  return stopProgressBar;
};

export default function* importViolations(action) {
  try {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    };
    const pool = action.payload;
    const url = `${BACKEND_URL_V2}/dict/violations/import`;
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true, headers, true);
    yield put(showProgressBar({
      title: 'Импорт нарушений',
      text: 'group.import.file',
    }));
    const data = yield dataResponse.json();

    if (dataResponse.status === CREATED) {
      let stopImport = false;
      while (!stopImport) {
        stopImport = yield select(getStop);
        const violationLoadPromise = yield put(loadStatusImport({ id: data.data.id }));
        const { data: violation } = yield violationLoadPromise;

        yield put(setProgressList({
          progressCount: violation?.total_rows,
          progressPercent: violation?.progress,
          progressCountSuccess: violation?.processed_rows,
        }));
        yield put(setLogList({ log: renderLog(violation) }));
        if (violation?.status === 4) {
          yield put(stoppedProgressBar());
          throw new Error('Импорт файла завершен с ошибкой');
        }
        if (violation?.status === 3) {
          yield put(stoppedProgressBar());
          break;
        }
        yield delay(2000);
      }
      yield put(addProgressLog({ log: 'Импорт успешно завершен' }));
      yield put(importViolationSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(importViolationFailed());
      yield handleImportFailure(data?.message);
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(importViolationFailed());
    yield handleImportFailure(e);
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}

const renderLog = items => {
  const errors = items?.errors || [];
  const errorMessages = errors.map(e => {
    const message = e.message || 'Ошибка без сообщения';
    const timestamp = e.created_at ? `[${dateTimeStringFormatter(e.created_at)}]` : '';
    return `${timestamp} ${message}`;
  });
  return errorMessages.map(msg => `<span>${msg}</span><br/>`);
};

function* handleImportFailure(error) {
  const time = moment().format('HH:mm:ss');
  yield put(addProgressLog({ log: `<span style="color: red">${time} - Ошибка импорта: ${error || 'Ошибка без сообщения'}</span>`, withOutTime: true }));
  yield put(stoppedProgressBar());
  yield put(setProgressList({ progressPercent: 100 }));
}
